var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDefaultCoverImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 359,
    height: 165,
    viewBox: "0 0 359 165",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-125%",
    x2: "50%",
    y2: "100%",
    id: "aeg5992u8b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE9AE5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5961F9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "6gj2vzyvna",
    d: "M0 0h359v165H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bb9qcy06tc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6gj2vzyvna"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    d: "M.5.5h358v164H.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#aeg5992u8b)",
    fillRule: "nonzero",
    mask: "url(#bb9qcy06tc)",
    cx: 81.5,
    cy: 76.5,
    rx: 167.5,
    ry: 166.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#aeg5992u8b)",
    fillRule: "nonzero",
    mask: "url(#bb9qcy06tc)",
    transform: "matrix(1 0 0 -1 0 153)",
    cx: 438.5,
    cy: 76.5,
    rx: 167.5,
    ry: 166.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDefaultCoverImage);
export default __webpack_public_path__ + "static/media/ic_default_cover_image.767429997ab9aa56a00eb2c7cff3827a.svg";
export { ForwardRef as ReactComponent };